export const VEHICLE_TYPE_KEY = 'e367'
